import { CardHeader, CardTitle } from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';

interface MonitorCardHeaderProps {
  name: string;
  description?: string;
  statusIcon: React.ReactNode;
  className?: string;
}

export function MonitorCardHeader({
  name,
  description,
  statusIcon,
  className,
}: MonitorCardHeaderProps) {
  return (
    <CardHeader
      className={cn(
        'flex flex-row items-center justify-between space-y-0 pb-2',
        className
      )}
    >
      <div className="flex-1 min-w-0">
        <CardTitle className="text-sm font-medium text-muted-foreground truncate">
          {name}
        </CardTitle>
        {description && (
          <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
            {description}
          </p>
        )}
      </div>
      <div className="flex items-center space-x-2 flex-shrink-0 ml-2">
        {statusIcon}
      </div>
    </CardHeader>
  );
}
